import * as _ from 'lodash';
import * as React from 'react';
import { DataShape, Field, FormProps, reduxForm } from 'redux-form';

import history from 'login-utils/history';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import * as onboardingForm from 'login-utils/onboardingForm';
import LargeIconButtonGroup from 'login-components/Common/LargeIconButtonGroup/LargeIconButtonGroup';
import { LargeIconButtonConfig } from 'login-components/Common/Buttons/LargeIconButton';
import PersonalLoanSVG from 'login-components/Common/svg/PersonalLoanSVG';
import PersonalLineOfCreditSVG from 'login-components/Common/svg/PersonalLineOfCreditSVG';
import States from 'login-constants/states';

const personalLoanTypeConfigs: LargeIconButtonConfig[] = [
  {
    value: 'PERSONAL_LOAN',
    iconComponent: PersonalLoanSVG,
    buttonId: 'it-choosePersonalLoanTypePersonalLoan',
    text: 'Personal loan',
    subText: 'Borrow a lump sum and pay it back over time.',
  },
  {
    value: 'PERSONAL_LOC',
    iconComponent: PersonalLineOfCreditSVG,
    buttonId: 'it-choosePersonalLoanTypePersonalLOC',
    text: 'Personal line of credit',
    subText: 'Borrow as needed through a line of credit.',
  },
];

namespace PersonalLoanType {
  export type Props = ReactRouter.RouteComponentProps<{}, {}>;
}

export class PersonalLoanType extends React.Component<PersonalLoanType.Props> {
  getLoanTypeConfigs = () => {
    const { supportedLoanTypes } = deploymentConfig.get();
    return _.filter(personalLoanTypeConfigs, ({ value }) => _.includes(supportedLoanTypes, value));
  };

  onSelect = () => {
    history.push(States.CREATE_ACCOUNT);
  };

  render(): React.ReactNode {
    return (
      <Field
        name={onboardingForm.FIELDS.loanType}
        configs={this.getLoanTypeConfigs()}
        onSelect={this.onSelect}
        component={LargeIconButtonGroup}
      />
    );
  }
}

export default reduxForm<FormProps<DataShape, PersonalLoanType.Props, ReduxState>, PersonalLoanType.Props, ReduxState>(
  onboardingForm.FORM_CONFIG,
)(PersonalLoanType);
